<div
    class="content"
    *ngIf="selected">
    <ng-content></ng-content>
</div>
